import React from "react";
import ServiceCard from "../components/ServiceCard";
import DecorativeCircle from "../components/DecorativeCircle";
import BookUsBanner from "../components/BookUsBanner";
import PhotoGallery from "../components/PhotoGallery";

import photoLab from "../images/photos/lab.jpg";
import photoOr from "../images/photos/or.jpg";
import photoHospital from "../images/photos/DSCF3813.jpg";
import photoHospital2 from "../images/photos/DSCF3820.jpg";
import photoHospital3 from "../images/photos/DSCF3824.jpg";
import photoRehab from "../images/photos/DSCF3863.jpg";
import photoReception from "../images/photos/DSCF3793.jpg";
import {
  NeurologyIcon,
  PhysiatryIcon,
  TraumatologyIcon,
  CardiologyIcon,
  DermatologyIcon,
  FelineMedicineIcon,
  EndocrinologyIcon,
} from "../icons";

const Servicios = () => {
  const galleryPhotos = [
    { src: photoLab, alt: "Laboratorio clínico" },
    { src: photoOr, alt: "Pabellón quirúrgico" },
    { src: photoHospital, alt: "Hospitalización" },
    { src: photoHospital2, alt: "Cuidados hospitalarios" },
    { src: photoRehab, alt: "Rehabilitación" },
    { src: photoHospital3, alt: "Equipo hospitalario" },
    { src: photoReception, alt: "Farmacia y recepción" },
  ];

  const services = [
    {
      icon: <NeurologyIcon />,
      title: "Laboratorio Clínico",
      description:
        "Análisis clínicos y pruebas de laboratorio para diagnóstico veterinario preciso.",
      delay: ".2s",
    },
    {
      icon: <PhysiatryIcon />,
      title: "Imagenología",
      description:
        "Servicios de diagnóstico por imágenes incluyendo radiografías y ecografías.",
      delay: ".3s",
    },
    {
      icon: <TraumatologyIcon />,
      title: "Hospitalización",
      description:
        "Atención hospitalaria y cuidados intensivos para pacientes que requieren monitoreo continuo.",
      delay: ".4s",
    },
    {
      icon: <EndocrinologyIcon />,
      title: "Electrodiagnóstico",
      description:
        "Electroencefalografía para diagnostico de afecciones que afectan el cerebro.",
      delay: ".7s",
    },
    {
      icon: <CardiologyIcon />,
      title: "Urgencias",
      description: "Atención de emergencias veterinarias y neurológicas.",
      delay: ".5s",
    },
    {
      icon: <DermatologyIcon />,
      title: "Farmacia",
      description: "Venta de medicamentos y productos farmacéuticos.",
      delay: ".6s",
    },
    {
      icon: <FelineMedicineIcon />,
      title: "Pet Shop",
      description:
        "Productos y accesorios para mascotas incluyendo alimentos, juguetes y artículos de cuidado.",
      delay: ".7s",
    },
  ];

  return (
    <>
      {/* Services Section */}
      <section id="services" className="relative z-10 pt-[110px] pb-[110px]">
        <DecorativeCircle position="right-bottom" />

        <div className="container">
          <div
            className="wow fadeInUp mx-auto mb-14 max-w-[690px] text-center lg:mb-[70px]"
            data-wow-delay=".2s"
          >
            <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
              Nuestros Servicios
            </h2>
            <p className="text-base text-body">
              Ofrecemos una amplia gama de servicios veterinarios.
            </p>
          </div>
        </div>

        <div className="container max-w-[1390px]">
          <div className="px-5 bg-white rounded-2xl pt-14 pb-14 shadow-card dark:bg-dark dark:shadow-card-dark md:pb-1 lg:pt-20 lg:pb-5 xl:px-10">
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {services.map((service, index) => (
                <ServiceCard
                  key={index}
                  icon={service.icon}
                  title={service.title}
                  description={service.description}
                  delay={service.delay}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <PhotoGallery
        photos={galleryPhotos}
        title="Nuestras Instalaciones"
        description="Equipamiento y espacios diseñados para el mejor cuidado de tu mascota."
      />

      <BookUsBanner />
    </>
  );
};

export default Servicios;
